<template>
  <div class="hot-zone">
    <v-zone
      v-if="image.url"
      :zone="hot_zone"
      :image="image"
      :class="mobile_image && mobile_image.url ? 'd-md-block d-none' : ''"
    ></v-zone>
    <v-zone
      v-if="mobile_image.url"
      :zone="mobile_hot_zone"
      :image="mobile_image"
      class="d-md-none d-block"
    ></v-zone>
  </div>
</template>
<script>
import vZone from "./zone.vue";
export default {
  props: {
    hotZoneData: {},
  },
  data() {
    return {
      hot_zone: [],
      image: {},
      mobile_hot_zone: [],
      mobile_image: {},
    };
  },
  watch: {
    hotZoneData: {
      handler(newV) {
        let { hot_zone, image, mobile_hot_zone, mobile_image } = newV;
        this.hot_zone = hot_zone?.length ? hot_zone : [];
        this.mobile_hot_zone = mobile_hot_zone?.length ? mobile_hot_zone : [];
        this.image = image || {};
        this.mobile_image = mobile_image || {};
      },
      immediate: true,
    },
  },
  components: {
    vZone,
  },
};
</script>